import React, { useEffect, useState } from 'react';
import { Timer as TimerIcon } from 'lucide-react';

const Timer = ({ timeLimit, isActive, onTimeExpired, theme }) => {
    const [timeLeft, setTimeLeft] = useState(timeLimit);

    useEffect(() => {
        setTimeLeft(timeLimit);
      }, [timeLimit, isActive]);

    useEffect(() => {
    let interval;
    
    if (isActive && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            onTimeExpired();
            return timeLimit; // Reset to full time
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [isActive, timeLeft, onTimeExpired, timeLimit]);

  // Format time as MM:SS
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const timeString = `${minutes}:${seconds.toString().padStart(2, '0')}`;

  // Calculate percentage for visual feedback
  const percentage = (timeLeft / timeLimit) * 100;
  const getTimerColor = () => {
    if (percentage > 66) return 'text-green-500';
    if (percentage > 33) return 'text-yellow-500';
    return 'text-red-500';
  };

  return (
    <div className={`flex items-center gap-2 ${theme.text}`}>
      <TimerIcon className={`w-5 h-5 ${getTimerColor()}`} />
      <span className={`font-mono ${getTimerColor()}`}>
        {timeString}
      </span>
    </div>
  );
};

export default Timer;